const BASE_URL = 'https://www.prrepxpathshala.live';
const DEFAULT_IMAGE = `${BASE_URL}/PrepXPathshala_logo2.jpg`;
const SITE_NAME = 'PrrepX Pathshala';

const pageMeta = {
  '/': {
    title: 'PrrepX Pathshala — One-Stop Learning for IIT-JEE, NEET & CBSE Classes 6-12',
    description: 'A growing learning destination for serious IIT-JEE, NEET and CBSE Classes 6-12 aspirants: video tutorials, doubt support, practice questions, PYQs, study materials, test series, syllabus resources and career guidance after Class 12.',
  },
  '/about-prrepx': {
    title: "About PrrepX Pathshala — India's Premier Online Learning Platform",
    description: "Learn about PrrepX Pathshala's mission to make premium IIT-JEE, NEET & Class 6-12 education accessible and affordable for every Indian student.",
  },
  '/meetourteam': {
    title: 'Meet Our Team — PrrepX Pathshala',
    description: 'Meet the IIT, NIT & top medical alumni who are building India\'s most affordable and authentic learning platform at PrrepX Pathshala.',
  },
  '/enquiry-now': {
    title: 'Contact Us — PrrepX Pathshala',
    description: 'Have questions? Reach out to PrrepX Pathshala. We are here to help you with your IIT-JEE, NEET & school exam preparation journey.',
  },
  '/careers': {
    title: 'Careers at PrrepX Pathshala — Join Our Mission',
    description: 'Join PrrepX Pathshala and help make world-class education accessible to every Indian student. Explore open positions and internships.',
  },
  '/tutorials': {
    title: 'Free Video Tutorials — PrrepX Pathshala',
    description: 'Watch free video lectures for IIT-JEE, NEET, and Class 6-12 by top IIT/NIT alumni. Chapter-wise organized tutorials for every subject.',
  },

  // IIT-JEE Lectures
  '/tutorials/iitjee-physics': {
    title: 'IIT-JEE Physics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Master IIT-JEE Physics with free chapter-wise video lectures by IIT alumni. Mechanics, Electrodynamics, Optics, Thermodynamics & more.',
  },
  '/tutorials/iitjee-chemistry': {
    title: 'IIT-JEE Chemistry Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Master IIT-JEE Chemistry with free chapter-wise video lectures. Physical, Organic & Inorganic Chemistry covered by top faculty.',
  },
  '/tutorials/iitjee-mathematics': {
    title: 'IIT-JEE Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Master IIT-JEE Maths with free chapter-wise video lectures. Algebra, Calculus, Coordinate Geometry, Trigonometry & more.',
  },

  // NEET Lectures
  '/tutorials/neet-biology': {
    title: 'NEET Biology Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Master NEET Biology with free chapter-wise video lectures. Botany, Zoology, Human Physiology, Genetics & Ecology covered.',
  },

  // Class 12 Lectures
  '/tutorials/class12-physics': {
    title: 'Class 12 Physics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 12 Physics video lectures. Electrostatics, Current Electricity, Optics, Modern Physics & more. CBSE & board exam focused.',
  },
  '/tutorials/class12-chemistry': {
    title: 'Class 12 Chemistry Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 12 Chemistry video lectures. Solutions, Electrochemistry, Chemical Kinetics, Organic Chemistry & more for CBSE boards.',
  },
  '/tutorials/class12-mathematics': {
    title: 'Class 12 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 12 Maths video lectures. Relations & Functions, Calculus, Vectors, 3D Geometry, Probability & more for CBSE boards.',
  },
  '/tutorials/class12-biology': {
    title: 'Class 12 Biology Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 12 Biology video lectures. Reproduction, Genetics, Evolution, Ecology, Biotechnology & more for CBSE boards.',
  },

  // Class 11 Lectures
  '/tutorials/class11-physics': {
    title: 'Class 11 Physics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 11 Physics video lectures. Units, Kinematics, Laws of Motion, Work Energy, Thermodynamics & more.',
  },
  '/tutorials/class11-chemistry': {
    title: 'Class 11 Chemistry Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 11 Chemistry video lectures. Atomic Structure, Chemical Bonding, States of Matter, Equilibrium & more.',
  },
  '/tutorials/class11-mathematics': {
    title: 'Class 11 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 11 Maths video lectures. Sets, Trigonometry, Complex Numbers, Sequences, Straight Lines, Conic Sections & more.',
  },
  '/tutorials/class11-biology': {
    title: 'Class 11 Biology Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 11 Biology video lectures. Cell Biology, Plant Physiology, Animal Physiology, Biomolecules & more.',
  },

  // Class 10 Lectures
  '/tutorials/class10-mathematics': {
    title: 'Class 10 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 10 Maths video lectures. Real Numbers, Polynomials, Quadratic Equations, Trigonometry, Geometry & more for CBSE.',
  },
  '/tutorials/class10-science': {
    title: 'Class 10 Science Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 10 Science video lectures. Chemical Reactions, Life Processes, Light, Electricity, Magnetic Effects & more for CBSE.',
  },

  // Class 9 Lectures
  '/tutorials/class9-mathematics': {
    title: 'Class 9 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 9 Maths video lectures. Number Systems, Polynomials, Coordinate Geometry, Triangles, Statistics & more for CBSE.',
  },
  '/tutorials/class9-science': {
    title: 'Class 9 Science Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 9 Science video lectures. Matter, Atoms, Motion, Force, Gravitation, Work & Energy, Sound & more for CBSE.',
  },

  // Class 8 Lectures
  '/tutorials/class8-mathematics': {
    title: 'Class 8 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 8 Maths video lectures. Rational Numbers, Linear Equations, Quadrilaterals, Data Handling & more for CBSE.',
  },
  '/tutorials/class8-science': {
    title: 'Class 8 Science Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 8 Science video lectures. Crop Production, Microorganisms, Synthetic Fibres, Metals, Coal, Combustion & more.',
  },

  // Class 7 Lectures
  '/tutorials/class7-mathematics': {
    title: 'Class 7 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 7 Maths video lectures. Integers, Fractions, Decimals, Algebraic Expressions, Triangles & more for CBSE.',
  },
  '/tutorials/class7-science': {
    title: 'Class 7 Science Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 7 Science video lectures. Nutrition, Fibre to Fabric, Heat, Acids Bases, Physical Chemical Changes & more.',
  },

  // Class 6 Lectures
  '/tutorials/class6-mathematics': {
    title: 'Class 6 Mathematics Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 6 Maths video lectures. Knowing Our Numbers, Whole Numbers, Playing With Numbers, Geometry & more for CBSE.',
  },
  '/tutorials/class6-science': {
    title: 'Class 6 Science Lectures — Free Video Tutorials | PrrepX Pathshala',
    description: 'Free Class 6 Science video lectures. Food, Fibre to Fabric, Sorting Materials, Separation, Changes Around Us & more.',
  },

  '/tutorials/biology-placeholder': {
    title: 'Biology Lectures — Coming Soon | PrrepX Pathshala',
    description: 'Biology video lectures are being prepared. Stay tuned for comprehensive coverage of NEET & CBSE Biology topics.',
  },

  // School
  '/prepxpathshala-school': {
    title: 'PrrepX Pathshala School — Online Classes for Class 6-12',
    description: 'PrrepX Pathshala School brings expert-led online classes for Class 6-12 students. CBSE curriculum, interactive lectures & doubt support.',
  },

  // PYQs
  '/pyqs/chapterwise': {
    title: 'Chapter-wise Previous Year Questions (PYQs) — PrrepX Pathshala',
    description: 'Practice chapter-wise previous year questions for IIT-JEE & NEET. Sorted by topic with detailed solutions and answer keys.',
  },
  '/pyqs/yearwise': {
    title: 'Year-wise Previous Year Questions (PYQs) — PrrepX Pathshala',
    description: 'Practice year-wise IIT-JEE & NEET previous year question papers. Complete papers with solutions from 2015-2025.',
  },
  '/pyqs/mathematics/sets-relations-functions': {
    title: 'Sets, Relations & Functions PYQs — IIT-JEE Mathematics | PrrepX Pathshala',
    description: 'Practice IIT-JEE previous year questions on Sets, Relations & Functions with detailed solutions.',
  },
  '/pyqs/mathematics/logarithms': {
    title: 'Logarithms PYQs — IIT-JEE Mathematics | PrrepX Pathshala',
    description: 'Practice IIT-JEE previous year questions on Logarithms with step-by-step solutions.',
  },
  '/pyqs/mathematics/quadratic-equations': {
    title: 'Quadratic Equations PYQs — IIT-JEE Mathematics | PrrepX Pathshala',
    description: 'Practice IIT-JEE previous year questions on Quadratic Equations with detailed solutions.',
  },

  // Syllabus pages
  '/iitjee-syllabus': {
    title: 'IIT-JEE Syllabus 2026 — Complete JEE Main & Advanced Syllabus | PrrepX Pathshala',
    description: 'Complete IIT-JEE Main & Advanced 2026 syllabus for Physics, Chemistry & Mathematics. Topic-wise breakdown with weightage analysis.',
  },
  '/neet-syllabus': {
    title: 'NEET Syllabus 2026 — Complete NEET-UG Syllabus | PrrepX Pathshala',
    description: 'Complete NEET-UG 2026 syllabus for Physics, Chemistry & Biology. Topic-wise breakdown with chapter weightage analysis.',
  },
  '/cbse10th-syllabus': {
    title: 'CBSE Class 10 Syllabus 2026 — Complete Subject-wise Syllabus | PrrepX Pathshala',
    description: 'Complete CBSE Class 10 syllabus for 2025-26. Maths, Science, English, Social Science — chapter-wise with marking scheme.',
  },
  '/cbse12th-syllabus': {
    title: 'CBSE Class 12 Syllabus 2026 — Complete Subject-wise Syllabus | PrrepX Pathshala',
    description: 'Complete CBSE Class 12 syllabus for 2025-26. Physics, Chemistry, Maths, Biology — chapter-wise with marking scheme.',
  },

  // Student features
  '/study-materials': {
    title: 'Free Study Materials — Notes, PDFs & Resources | PrrepX Pathshala',
    description: 'Download free study materials for IIT-JEE, NEET & CBSE Class 6-12. Chapter-wise notes, formula sheets, and practice resources.',
  },
  '/doubt-portal24*7': {
    title: '24/7 Doubt Portal — Ask Your Doubts Anytime | PrrepX Pathshala',
    description: 'Get your academic doubts resolved 24/7 by expert mentors. Submit questions in Physics, Chemistry, Maths or Biology.',
    indexable: false,
  },
  '/community-page': {
    title: 'Student Community — Connect & Learn Together | PrrepX Pathshala',
    description: 'Join the PrrepX Pathshala student community. Discuss topics, share resources, and learn together with fellow aspirants.',
  },
  '/confidential-support': {
    title: 'Confidential Support — Private Help from Mentors | PrrepX Pathshala',
    description: 'Get private, confidential academic and personal support from PrrepX Pathshala mentors. Your conversations are secure.',
    indexable: false,
  },

  // Auth pages
  '/login': {
    title: 'Login — PrrepX Pathshala',
    description: 'Log in to your PrrepX Pathshala account to access free lectures, study materials, doubt portal and more.',
    indexable: false,
  },
  '/signup': {
    title: 'Sign Up — PrrepX Pathshala',
    description: 'Create your free PrrepX Pathshala account. Get access to free lectures, study materials, doubt portal and community.',
    indexable: false,
  },
  '/profile': {
    title: 'My Profile — PrrepX Pathshala',
    description: 'Manage your PrrepX Pathshala profile, track your learning progress and update your account settings.',
    indexable: false,
  },

  // Career guidance
  '/after12': {
    title: 'Career Guidance After 12th — Explore All Options | PrrepX Pathshala',
    description: 'Confused about what to do after 12th? Explore career paths in Engineering, Medical, Commerce, Arts, Design & more with expert guidance.',
  },

  // Legal pages
  '/privacy-policy': {
    title: 'Privacy Policy — PrrepX Pathshala',
    description: 'Read PrrepX Pathshala\'s privacy policy. Learn how we collect, use, and protect your personal information.',
  },
  '/terms-conditions': {
    title: 'Terms & Conditions — PrrepX Pathshala',
    description: 'Read the terms and conditions for using PrrepX Pathshala\'s website and services.',
  },
  '/refund-policy': {
    title: 'Refund & Cancellation Policy — PrrepX Pathshala',
    description: 'Read PrrepX Pathshala\'s refund and cancellation policy for courses and premium content.',
  },
  '/shipping-policy': {
    title: 'Shipping Policy — PrrepX Pathshala',
    description: 'Read PrrepX Pathshala\'s shipping and delivery policy for physical materials and resources.',
  },

  // Admin
  '/admin/doubts': {
    title: 'Admin Doubt Portal — PrrepX Pathshala',
    description: 'Admin portal for managing and answering student doubts on PrrepX Pathshala.',
    indexable: false,
  },
  '/admin/disha': {
    title: 'Admin Disha Chats — PrrepX Pathshala',
    description: 'Private administration portal for managing student support conversations.',
    indexable: false,
  },
  '/user-management': {
    title: 'User Management — PrrepX Pathshala Admin',
    description: 'Manage users and student accounts on PrrepX Pathshala.',
    indexable: false,
  },

  // Tests
  '/test/jee2020_1_1': {
    title: 'JEE 2020 Paper 1 — Practice Test | PrrepX Pathshala',
    description: 'Practice JEE 2020 Paper 1 with timer, auto-scoring and detailed solutions on PrrepX Pathshala.',
    indexable: false,
  },
  '/test/physics-hiring': {
    title: 'Physics Assessment Test — PrrepX Pathshala',
    description: 'Take the Physics assessment test on PrrepX Pathshala.',
    indexable: false,
  },
  '/test/chemistry-hiring': {
    title: 'Chemistry Assessment Test — PrrepX Pathshala',
    description: 'Take the Chemistry assessment test on PrrepX Pathshala.',
    indexable: false,
  },
};

// Default fallback meta
const defaultMeta = {
  title: 'PrrepX Pathshala — One-Stop Learning for IIT-JEE, NEET & CBSE Classes 6-12',
  description: 'A growing learning destination for serious IIT-JEE, NEET and CBSE Classes 6-12 aspirants: video tutorials, doubt support, practice questions, PYQs, study materials, test series, syllabus resources and career guidance after Class 12.',
};

/**
 * Get meta data for a given route path.
 * Returns the page-specific meta or the default fallback.
 */
export function getPageMeta(pathname) {
  const meta = pageMeta[pathname] || defaultMeta;
  return {
    title: meta.title,
    description: meta.description,
    image: meta.image || DEFAULT_IMAGE,
    url: `${BASE_URL}${pathname}`,
    siteName: SITE_NAME,
    robots: meta.indexable === false || meta === defaultMeta ? 'noindex,follow' : 'index,follow,max-image-preview:large',
  };
}

export { pageMeta, defaultMeta, BASE_URL, DEFAULT_IMAGE, SITE_NAME };
